// Making sure footer content / links are fully accessible
// on desktop and mobile

export function footer() {
    let footerAccordionTriggers = Array.prototype.slice.call(document.querySelectorAll('.open-accordion .adage-accordion-trigger'));
    let footerAccordionPanels = Array.prototype.slice.call(document.querySelectorAll('.open-accordion .adage-accordion-panel'));

    function removeAriaLabels() {
        footerAccordionTriggers.forEach(accordionTrigger => {
            accordionTrigger.setAttribute('aria-expanded', true);
            accordionTrigger.setAttribute('tabindex', '-1');
        });
        footerAccordionPanels.forEach(accordionPanel => {
            accordionPanel.setAttribute('aria-hidden', false);

            let accordionLinks = Array.prototype.slice.call(accordionPanel.querySelectorAll('a[tabindex="-1"]'));

            accordionLinks.forEach(accordionLink => {
                accordionLink.removeAttribute('tabindex');
            });
        });
    }

    function addAriaLabels() {
        footerAccordionTriggers.forEach(accordionTrigger => {
            accordionTrigger.setAttribute('aria-expanded', false);
            accordionTrigger.removeAttribute('tabindex');
        });
        footerAccordionPanels.forEach(accordionPanel => {
            accordionPanel.setAttribute('aria-hidden', true);

            let accordionLinks = Array.prototype.slice.call(accordionPanel.querySelectorAll('a'));

            accordionLinks.forEach(accordionLink => {
                accordionLink.setAttribute('tabindex', '-1');
            });
        });
    }

    function setAriaLabels() {
        if (window.innerWidth > 600) {
            removeAriaLabels();
        } else {
            addAriaLabels();
        }
    }

    setAriaLabels();

    window.addEventListener('resize', function() {
        setAriaLabels();
    });
}
